import React, { Component } from "react";
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import { Link } from "react-router-dom";
import ReactTable from "react-table";
import "react-table/react-table.css";
import "./qrlist.css";
import { configuration } from "../../appConfig";
import Axios from "axios";
import Swal from "sweetalert2";
import moment from "moment";
import DatePicker from "react-date-picker";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import Cookies from "js-cookie";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

const currentDate = new Date();
const year = currentDate.getFullYear();
const month = String(currentDate.getMonth() + 1).padStart(2, "0");
const day = String(currentDate.getDate()).padStart(2, "0");
const formattedDate = `${year}-${month}-${day}`;
const cookieDate = Cookies.get("filterQRDate");
const cookiePageJump = Cookies.get("QRjumpPage");
const cookieEntriesLimit = Cookies.get("showEntriesLimit");
const isDateChanged = Cookies.get("QRdateChanged");
// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

class QrList extends Component {
  csvfile = React.createRef(null);
  state = {
    orders: [],
    color: "",
    startScan: false,
    count: 0,
    lang: "",
    words: {},
    loading: null,
    search: "",
    result: [],
    result_status: false,
    next_page: null,
    current_page: null,
    previous_page: null,
    searchNextPage: null,
    searchCurrentPage: null,
    searchPreviousPage: null,
    showUnderscoreVIN: false,
    startDate: moment(new Date()).format("YYYY-MM-DD"),
    downloading: false,
    uploading: false,
    error: [],
    fileCSVupload: "",
    cookieSetDate: Cookies.get("cookieSetDateQR")
      ? Cookies.get("cookieSetDateQR")
      : "",
    recordsPerPage: cookieEntriesLimit ? cookieEntriesLimit : 10,
    authorizeFilter: "",
    filterDate: isDateChanged ? cookieDate : formattedDate,
    jumpPage: cookiePageJump ? cookiePageJump : 1,
  };
  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({ words: res.data, lang: localStorage.getItem("lang") });
    });
  };

  initializeFromCookies = () => {
    const currentDate = this.getCurrentUTCDate();
    const cookieSetDate = Cookies.get("cookieSetDateQR");

    if (currentDate !== cookieSetDate) {
      // Clear cookies if the date has changed
      [
        "QRjumpPage",
        "filterQRDate",
        "showEntriesLimit",
        "dateChanged",
        "cookieSetDateQR",
        "QRdateChanged",
      ].forEach(Cookies.remove);
      this.setState({ cookieSetDate: currentDate }); // Reset the date in state
    } else {
      // Initialize state from cookies if the date matches
      this.setState(
        {
          jumpPage: Cookies.get("QRjumpPage") || 1,
          filterDate: Cookies.get("filterQRDate") || "",
          recordsPerPage: Cookies.get("showEntriesLimit") || 10,
          cookieSetDate: cookieSetDate || currentDate,
        },
        () => {
          this.search(this.state.jumpPage);
        }
      );
    }
  };
  componentDidMount() {
    this.getQrList("1");
    this.startTimer();
    this.checkServerscanStatus();
    this.getLang();
    this.initializeFromCookies();
  }

  getCurrentUTCDate = () => {
    const now = new Date();

    // Get UTC-based month, day, and year
    const month = now.getUTCMonth() + 1; // getUTCMonth returns 0-11, adding 1 for human-readable format
    const day = now.getUTCDate(); // getUTCDate returns the day of the month
    const year = now.getUTCFullYear(); // getUTCFullYear returns the 4-digit year

    // Format the date as MM/DD/YYYY
    const formattedDate = `${month}/${day}/${year}`;

    return formattedDate;
  };
  updateServer = () => {
    const partnerId = localStorage.getItem("partnerId");
    Axios.post(
      "http://driveandscan.de/scancommand/index.php?pid=" +
        partnerId +
        "&startScan=1",
      {}
    )
      .then((res) => {
        this.setState({ startScan: true, count: 0 });
        alert("Scan Initiated");
      })
      .catch((err) => {});
  };
  createLocalFile = () => {
    const url = "http://localhost:9001/api/v1/startScan";
    const payload = { color: this.state.color };
    Axios.post(url, payload)
      .then((res) => {
        this.updateServer();
      })
      .catch((err) => {
        alert("Error! Local Server Not Started..");
      });
  };
  checkServerscanStatus = () => {
    setInterval(() => {
      if (this.state.startScan) {
        const partnerId = localStorage.getItem("partnerId");
        Axios.post(
          "http://driveandscan.de/scancommand/index.php?pid=" +
            partnerId +
            "&getStatus=1",
          {}
        ).then((res) => {
          if (res.data.status === "0") {
            this.setState({ startScan: false });
          }
        });
      }
    }, 100000);
  };
  startTimer = () => {
    let count = this.state.count;

    setInterval(() => {
      if (this.state.startScan) {
        count = count + 1;
      }
      this.setState({ count });
    }, 100000);
  };
  getQrList = async (page) => {
    const partnerId = localStorage.getItem("partnerId");
    const next_page = page;
    const { showUnderscoreVIN, recordsPerPage } = this.state;
    this.setState({
      loading: true,
    });
    if (partnerId) {
      // const url = configuration.getQRList;
      // const url = `${configuration.getQRList}?partnerId=${partnerId}&page=${next_page}`
      const url = `${configuration.getQRListPaginate}?partnerId=${partnerId}&page=${next_page}&withUndescore=${showUnderscoreVIN}`;
      // const response = await Axios.get(url + "?partnerId=" + partnerId).catch(
      const response = await Axios.get(url).catch((err) => {});
      if (response && response.data) {
        const totalRecords = parseInt(response.data.total_records);
        const totalPages = Math.ceil(totalRecords / recordsPerPage);
        this.setState({
          next_page: response.data.next_page ? response.data.next_page : null,
          current_page: response.data.current_page
            ? response.data.current_page
            : 1,
          previous_page: response.data.previous_page
            ? response.data.previous_page
            : null,
          loading: false,
          jumpPage: response.data.current_page,
          totalPages,
        });
      }
      // add condition for empty json
      if (
        response &&
        response.data &&
        response.data.data &&
        response.data.data.length > 0 &&
        typeof response.data.data === "object"
      ) {
        const dd = response.data.data;
        //   const dd = response.data.data.filter(t=>{
        // return !t.vin.includes('_')
        //   })
        this.setState({ orders: dd, loading: false });
      } else {
        this.setState({ orders: {}, loading: false });
        if (response.data.status != 404 && response.data.success != false) {
          Toast.fire({
            type: "error",
            title: "Issue in JSON file",
          });
        }
      }
    } else {
      this.props.history.push("/login");
    }
  };

  loading = () => (
    // <div className="animated fadeIn pt-1 text-center">Loading...</div>
    <div className="text-center">
      <div className="spinner-border" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );

  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };
  static getDerivedStateFromProps(nextProps, prevState) {
    // alert(nextProps.lang+"123")
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else return null;
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
    if (e.target.value.trim() === "") {
      this.setState({
        result: [],
        result_status: false,
      });
    }
  };
  handleFilterDateChange = (date) => {
    this.setState({ filterDate: date, jumpPage: 1 });
    Cookies.set("QRjumpPage", this.state.jumpPage);
    Cookies.set("QRdateChanged", true);
  };
  search = async (nextPage) => {
    // if(this.state.search.trim()){

    this.setState({
      loading: true,
    });
    const {
      showUnderscoreVIN,
      authorizeFilter,
      filterDate,
      recordsPerPage,
      jumpPage,
    } = this.state;

    //   const now = new Date();

    Cookies.set("showEntriesLimit", recordsPerPage);
    Cookies.set("filterQRDate", filterDate || "");
    Cookies.set("QRjumpPage", nextPage);
    Cookies.set("cookieSetDateQR", this.getCurrentUTCDate());

    this.setState({ cookieSetDate: this.getCurrentUTCDate() });
    const partnerId = localStorage.getItem("partnerId");
    let url = `${
      configuration.SearchQRDetails
    }?partnerId=${partnerId}&searchkey=${this.state.search.trim()}&page=${nextPage}&withUndescore=${showUnderscoreVIN}`;

    if (recordsPerPage) {
      url = url + `&limit=${recordsPerPage}`;
    }
    if (filterDate) {
      url = url + `&date=${moment(filterDate).format("YYYY-MM-DD")}`;
    }
    if (authorizeFilter) {
      url = url + `&authorized=${authorizeFilter === "1" ? true : false}`;
    }

    // const url = `${configuration.SearchQRDetails}?partnerId=${partnerId}&searchkey=${this.state.search.trim()}&page=${nextPage}&withUndescore=${showUnderscoreVIN}`

    // Axios.get(url)
    //   .then((res) => {
    //     if(res.data){
    //         const totalRecords = parseInt(res.data.total_records);
    //         const totalPages = Math.ceil(totalRecords / recordsPerPage);
    //         this.setState({
    //           result : res.data.data,
    //           searchNextPage : res.data.next_page,
    //           searchCurrentPage : res.data.current_page ?  res.data.current_page : 1,
    //           searchPreviousPage : res.data.previous_page,
    //           result_status : true,
    //           loading : false,
    //           totalPages
    //         })
    //     }
    //   })
    //   .catch((err) => {
    //     // alert(err,"err")
    //     Toast.fire({
    //       type: "error",
    //       title: "Something Went Wrong",
    //       });
    //   });
    try {
      const res = await Axios.get(url);
      if (res.data) {
        const totalRecords = parseInt(res.data.total_records);
        const totalPages = Math.ceil(totalRecords / recordsPerPage);
        this.setState({
          result: res.data.data,
          searchNextPage: res.data.next_page,
          searchCurrentPage: res.data.current_page ? res.data.current_page : 1,
          searchPreviousPage: res.data.previous_page,
          result_status: true,
          loading: false,
          totalPages,
        });
      }
    } catch (err) {
      console.error(err);
      this.setState({ loading: false });
      Toast.fire({
        type: "error",
        title: "Something Went Wrong",
      });
    }
  };

  handleToggle = (e) => {
    this.setState(
      {
        showUnderscoreVIN: e.target.checked,
      },
      () => {
        const { result_status } = this.state;
        result_status ? this.search("1") : this.getQrList("1");
      }
    );
  };

  handleDateChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  generatePDFAllVinQr = () => {
    const { startDate, endDate } = this.state;
    this.setState({
      downloading: true,
    });
    let partnerId = localStorage.getItem("partnerId");
    let lang = localStorage.getItem("lang");
    const url = `${configuration.generatePDFAllVinQr}`;
    const payload = {
      from_date: moment(this.state.startDate).format("YYYY-MM-DD"),
      to_date: moment(this.state.startDate).format("YYYY-MM-DD"),
      qrType: "new",
      lang,
      partnerId,
    };
    Axios.post(url, payload)
      .then((res) => {
        if (res.data.status === 200) {
          this.downloadFile(res.data.data)
            .then(() => {
              this.setState({
                downloading: false,
              });
              Toast.fire({
                type: "success",
                // title: this.lang("Report Created successfully."),
              });
            })
            .catch((err) => {
              this.setState({
                downloading: false,
              });
              Toast.fire({
                type: "error",
                title: "Something Went Wrong",
              });
            });
        }
      })
      .catch((err) => {
        Toast.fire({
          type: "error",
          title: "Something Went wrong!",
        });
      });
  };
  downloadFile = async (pdf) => {
    var { startDate, endDate } = this.state;
    var startDate = moment(this.state.startDate).format("DD-MM-YYYY");
    // var endDate = moment(this.state.endDate).format("DD-MM-YYYY")
    let partnerId = localStorage.getItem("partnerId");

    const str = pdf;
    const word = "base64,";
    const index = str.indexOf(word);
    const result = str.substring(index + word.length);

    const b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
      const byteCharacters = atob(b64Data);
      const byteArrays = [];
      for (
        let offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      const blob = new Blob(byteArrays, { type: contentType });
      return blob;
    };

    const blob = b64toBlob(result, "application/zip");
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${partnerId}_${startDate}_QR details_.zip`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  capture = (e) => {
    if (e.target.files.length > 0) {
      this.setState(
        {
          fileCSVupload: e.target.files[0],
        },
        () => {
          this.excelRead();
        }
      );
    }
  };
  excelRead = () => {
    this.setState({
      uploading: true,
    });
    const { fileCSVupload } = this.state;
    const partnerId = localStorage.getItem("partnerId");
    // let payload = {
    //   partnerId,
    //   fileName : fileCSVupload
    // }
    const formData = new FormData();
    formData.append("fileName", fileCSVupload);
    formData.append("partnerId", localStorage.getItem("partnerId"));
    const url = configuration.excelRead;
    Axios.post(url, formData)
      .then((res) => {
        if (res.data.status === 200) {
          Toast.fire({
            type: "success",
            title: "Excel upload successfully!",
          });
          window.location.reload();
          this.setState({
            uploading: false,
          });
        } else {
          Toast.fire({
            type: "error",
            title: "Something went wrong!",
          });
          this.setState({
            uploading: false,
          });
        }
      })
      .catch((err) => {
        Toast.fire({
          type: "error",
          title: "Something went wrong!",
        });
      })
      .finally(() => {
        this.setState({
          fileCSVupload: "",
          uploading: false,
        });
        this.refs.csvfile.value = "";
      });
  };

  uploadCsvfile = () => {
    this.refs.csvfile.click();
  };
  calculateNewPage = (currentPage, oldRecordsPerPage, newRecordsPerPage) => {
    const currentStartIndex = (currentPage - 1) * oldRecordsPerPage;
    return Math.floor(currentStartIndex / newRecordsPerPage) + 1;
  };
  handleFilterChange = (e) => {
    const { name, value } = e.target;
    const { current_page, recordsPerPage } = this.state;

    if (name == "recordsPerPage") {
      const newRecordsPerPage = parseInt(value, 10);
      const newPage = this.calculateNewPage(
        current_page,
        recordsPerPage,
        newRecordsPerPage
      );

      this.setState(
        {
          [name]: newRecordsPerPage,
          current_page: newPage,
        },
        () => {
          this.search(newPage);
        }
      );
    } else {
      this.setState({
        [name]: value,
      });
    }
  };

  handleClearFilter = () => {
    this.setState(
      {
        authorizeFilter: "",
        filterDate: "",
        recordsPerPage: 10,
        jumpPage: 1,
      },
      () => this.search("1")
    );
  };

  render() {
    const {
      orders,
      result,
      result_status,
      previous_page,
      next_page,
      current_page,
      loading,
      searchNextPage,
      searchCurrentPage,
      searchPreviousPage,
      showUnderscoreVIN,
      recordsPerPage,
      filterDate,
      authorizeFilter,
      totalPages,
      jumpPage,
      search,
      startDate,
    } = this.state;
    const client = localStorage.getItem("client");
    const partnerId = localStorage.getItem("partnerId");
    const columns = [
      {
        Header: this.lang("Sr. No"),
        id: "row",
        maxWidth: 60,
        className: "tr-srno",
        filterable: false,
        Cell: (row) => {
          return <div>{row.index + 1}</div>;
        },
      },
      {
        Header: this.lang("VIN Number"),
        filterable: true,
        width: 200,
        className: "tr-vinnumber",
        maxWidth: 300,
        accessor: "vin",

        Cell: (props) => (
          <span
            style={{ textAlign: "center", cursor: "pointer" }}
            onClick={() => {
              localStorage.setItem("selectedFile", props.row.vin);
              localStorage.setItem("userSession", "");
              this.props.history.push({
                // pathname: "/createQR",
                pathname: "/newCreateQR",
                search: "?vin=" + props.row.vin,
                state: { detail: props.row },
              });
            }}
          >
            {props.value}
          </span>
        ),
      },
      {
        id: "Estimate Id", // Required because our accessor is not a string
        Header: this.lang("Estimate Id"),
        maxWidth: 200,
        className: "tr-estimateid",
        accessor: "estimateId",
        filterable: true,
      },
      {
        Header: this.lang("Reg Number"),
        filterable: true,
        maxWidth: 200,
        accessor: "reg",
        Cell: (props) => (
          <span
            style={{ textAlign: "center", cursor: "pointer" }}
            onClick={() => {
              localStorage.setItem("selectedFile", props.row.vin);
            }}
          >
            {props.value}
          </span>
        ),
      },

      {
        id: "Make", // Required because our accessor is not a string
        Header: this.lang("Make"),
        maxWidth: 200,
        accessor: "make",
      },
      {
        id: "Model", // Required because our accessor is not a string
        Header: this.lang("Model"),
        maxWidth: 200,
        accessor: "model",
      },
      {
        id: "Color", // Required because our accessor is not a string
        Header: this.lang("Color"),
        maxWidth: 100,
        accessor: "color",
      },

      {
        id: "InsurenceName", // Required because our accessor is not a string
        Header: this.lang("Insurance Client"),
        maxWidth: 100,
        accessor: "InsurenceName",
      },

      // {
      //   id: "Date", // Required because our accessor is not a string
      //   Header: this.lang("Date"),
      //   maxWidth: 100,
      //   accessor: "scanDate",
      //   Cell: (props) => <span>{props.value.split(" ")[0]}</span>,
      // },
      {
        id: "Time", // Required because our accessor is not a string
        Header: this.lang("Time"),
        maxWidth: 100,
        accessor: "scanDate",
        Cell: (props) => <span>{props.value.split(" ")[1]}</span>,
      },

      {
        Header: (props) => <span>{this.lang("QR")}</span>, // Custom header components!
        minWidth: 150,
        Cell: (props) => (
          <button
            style={{}}
            className="btn btn-outline-info text-decoration-none"
            onClick={() => {
              localStorage.setItem("selectedFile", props.row.vin);
              window.open(window.location.origin + "/ViewQR");
              // this.props.history.push("ViewQR");
            }}
          >
            {" "}
            <i className="fa fa-qrcode" /> QR
          </button>
        ),
      },

      // {
      //   Header: (props) => <span>{this.lang("After Repair")}</span>, // Custom header components!
      //   minWidth: 150,
      //   Cell: (props) => (
      //     <>
      //     <button style={{}} className="btn btn-outline-info text-decoration-none">
      //       <a
      //         className="text-decoration-none"
      //         href={`https://drivenscan.app/qr/qr_b8.php?estimateID=${props.row["Estimate Id"]}&vin=${props.row.vin}_R&regno=${props.row.reg}&make=${props.row.Make}&model=${props.row.Model}&color=${props.row.Color}`}
      //         target="_blank"
      //         rel="noopener noreferrer"
      //         onClick={() => {
      //         }}
      //       >
      //         <i className="fa fa-qrcode" /> {this.lang("QR_A")}
      //       </a>
      //     </button>
      //     </>
      //   ),
      // },

      {
        Header: (props) => <span>{this.lang("Images")}</span>, // Custom header components!
        minWidth: 180,
        Cell: (props) => (
          <span style={{}}>
            <Link
              className="btn btn-outline-info text-decoration-none"
              style={{ fontSize: 17 }}
              to="/ExtraImages/123"
              onClick={() => {
                localStorage.setItem("selectedFile", props.row.vin);
              }}
            >
              <i className="fa fa-picture-o" aria-hidden="true"></i> Take
              Pictures
            </Link>
          </span>
        ),
      },
    ];
    const tableProps = {
      defaultPageSize: 5,
      filterable: false,
      defaultSortDesc: false,
      showPagination: true,
      showPageSizeOptions: false,
    };
    function filterCaseInsensitive(filter, row) {
      const id = filter.pivotId || filter.id;
      return row[id] !== undefined
        ? String(row[id].toLowerCase()).startsWith(filter.value.toLowerCase())
        : true;
    }
    return (
      <div className="animated fadeIn qr-list-table">
        <input
          type="file"
          name="filecsv"
          id="file"
          ref="csvfile"
          accept=".csv"
          capture="environment"
          style={{ display: "none" }}
          onChange={(e) => this.capture(e)}
        />
        <Row>
          <Col lg={12} sm={12} md={12} className="qr_list_header">
            <div className="card m-0">
              <CardHeader>
                <div className="row p-0 align-items-center">
                  <Col lg={6} sm={6} md={6} className="col-6">
                    <h4 className="qr_list_header">{this.lang("QR List")}</h4>
                  </Col>
                  <Col lg={6} sm={6} md={6} className="col-6">
                    {/* <Link to="createQR">
                      <button
                        type="button "
                        className="btn btn-lg pull-right new-qr-btn text-float"
                      >
                        <i className="mdi mdi-qrcode "></i>{" "}
                        {this.lang("Create QR")}
                      </button>
                    </Link> */}
                    {/* {localStorage.getItem("partnerId") === "002-sa" && ( */}
                      <Link to="newCreateQR">
                        <button
                          type="button "
                          className="btn btn-lg pull-right new-qr-btn text-float"
                        >
                          <i className="mdi mdi-qrcode "></i>{" "}
                          {this.lang("Create QR")}
                        </button>
                      </Link>
                    {/* )} */}
                  </Col>
                </div>
              </CardHeader>
            </div>
          </Col>
        </Row>
        {/* React table */}
        {/* <Row>
                <Col>
                  <Card>
                    <div className="CardBody p-0">
                      <ReactTable
                        loading = {this.state.loading}
                        id="t12"
                        style={{ textAlign: "center" }}
                        data={this.state.orders}
                        columns={columns}
                        {...tableProps}
                        minRows={0}
                        defaultPageSize={15}
                        defaultFilterMethod={(filter, row) =>
                          filterCaseInsensitive(filter, row)
                        }
                      />
                    </div>
                  </Card>
                </Col>
              </Row> */}
        <Row>
          <Col>
            <Card className="qr_list_table_main">
              <div className="CardBody p-0">
                {/* Table for QR list */}
                <div className="text-right searchbar_input">
                  <div className="row justify-content-between align-items-center">
                    {/* {(partnerId === "HXAG-01" || partnerId === "8-200406-1" || partnerId === "1-190301-1" || partnerId === "6-200406"|| partnerId === "002-sa"
                          || partnerId === "16-220515"|| partnerId === "WW-001"|| partnerId === "demo-de"|| partnerId === "23-230315"|| partnerId === "23-230315-1" || partnerId === "27-240415") && */}
                    <div className="col-lg-5 col-md-6 col-sm-12 searchbar_input_main p-0">
                      <div className="row d-flex align-items-center p-0">
                        <div className="col-lg-5 col-md-5 col-sm-6 p-1">
                          {/* <input type="date" className="form-control " name="startDate" value={this.state.startDate} onChange={this.handleDateChange}/> */}
                          <div className="main_datepicker_wrapper">
                            {
                              localStorage.getItem("client") == "US" || localStorage.getItem("client") == "CANADA" ? 
                              <DatePicker
                                name="startDate"
                                className="filter-date-picker"
                                value={startDate ? new Date(startDate) : null}
                                format="MM/dd/yyyy"
                                onChange={(date) =>
                                  this.setState({ startDate: date })
                                }
                              />
                              :
                              <DatePicker
                                name="startDate"
                                className="filter-date-picker"
                                value={startDate ? new Date(startDate) : null}
                                format="dd.MM.yyyy"
                                onChange={(date) =>
                                  this.setState({ startDate: date })
                                }
                              />
                            }
                          </div>
                        </div>
                        {/* <div className="col-lg-5 col-md-5 col-sm-12 p-1">
                                 <input type="date" className="form-control " name="endDate" value={this.state.endDate} onChange={this.handleDateChange}/>
                               </div> */}
                        <div className="col-lg-2 col-md-3 col-sm-3 col-6 p-1">
                          <button
                            className="download_pdf"
                            onClick={() => this.generatePDFAllVinQr()}
                          >
                            {this.state.downloading ? (
                              <div
                                className="spinner-border"
                                role="status"
                                style={{ width: "1.5rem", height: "1.5rem" }}
                              >
                                <span className="sr-only">Loading...</span>
                              </div>
                            ) : (
                              <i
                                className="fa fa-download"
                                aria-hidden="true"
                              ></i>
                            )}
                          </button>
                        </div>
                        {/* <div className="col-lg-2 col-md-3 col-sm-3 col-6 p-1">
                                 <button className="download_pdf upload_btn"
                                   onClick={() => this.uploadCsvfile()}
                                 >
                                   {this.state.uploading ?
                                     <div className="spinner-border" role="status" style={{ width: "1.5rem", height: "1.5rem" }}>
                                       <span className="sr-only">Loading...</span>
                                     </div>
                                     :
                                     <i className="fa fa-upload" aria-hidden="true"></i>
                                   }
                                 </button>
                               </div> */}
                      </div>
                    </div>
                    {/* } */}

                    <div className="col-lg-3 col-md-5 col-sm-12 searchbar_input_main">
                      {client === "CZ" && (
                        <div className="admin-list">
                          <label className="name pr-2">
                            {this.lang("showOtherVIN")}
                          </label>
                          <div className="switch-button switch-button-lg">
                            <input
                              type="checkbox"
                              name="underscore"
                              id="underscore"
                              onClick={(e) => this.handleToggle(e)}
                              checked={showUnderscoreVIN}
                            />
                            <span>
                              <label htmlFor="underscore"></label>
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-12 searchbar_input_main">
                      <input
                        type="text"
                        name="search"
                        value={this.state.search}
                        className="form-control w-100 d-inline mx-3"
                        onChange={(e) => this.handleChange(e)}
                        onKeyPress={(e) => {
                          if (e.key === "Enter") {
                            this.setState(
                              {
                                jumpPage: "",
                              },
                              () => this.search("1")
                            );
                          }
                        }}
                        placeholder={this.lang("Search")}
                      />
                      {result_status && search.trim() && (
                        <button
                          className="close_button"
                          onClick={() => {
                            this.setState(
                              {
                                search: "",
                              },
                              () => this.search("1")
                            );
                          }}
                        >
                          <i className="fa fa-close"></i>
                        </button>
                      )}
                      <button
                        className="search_icon_button"
                        onClick={() => {
                          this.setState(
                            {
                              jumpPage: "",
                            },
                            () => this.search("1")
                          );
                        }}
                      >
                        {/* {this.lang("search")} */}
                        <i className="fa fa-search"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div className="row p-0 m-0 record_selection_row align-items-end justify-content-between">
                  <div className="col-lg-3 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>{this.lang("showEntries")}</label>
                      <select
                        className="form-control"
                        name="recordsPerPage"
                        onChange={(e) => this.handleFilterChange(e)}
                        value={recordsPerPage}
                      >
                        {[10, 20, 30, 40, 50, 100].map((e) => (
                          <option>{e}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label className="d-block">
                        {this.lang("selectDate")}{" "}
                        <span
                          onClick={() =>
                            this.setState({ filterDate: "" }, () =>
                              this.search(current_page)
                            )
                          }
                        ></span>
                      </label>
                      {/* <input 
                                  className="form-control"
                                  type="date"
                                  name="filterDate"
                                  value={filterDate}
                                  onChange={this.handleFilterChange}
                                /> */}
                      <div className="main_datepicker_wrapper">
                      {
                        localStorage.getItem("client") == "US" || localStorage.getItem("client") == "CANADA" ? 
                        <DatePicker
                          className="filter-date-picker"
                          value={filterDate ? new Date(filterDate) : null}
                          format="MM/dd/yyyy"
                          onChange={(date) => this.handleFilterDateChange(date)}
                        />
                        :
                        <DatePicker
                          className="filter-date-picker"
                          value={filterDate ? new Date(filterDate) : null}
                          format="dd.MM.yyyy"
                          onChange={(date) => this.handleFilterDateChange(date)}
                        />
                      }
                      </div>
                      {/* <DatePicker 
                                  name="filterDate"
                                  className="form-control w-100"
                                  selected={filterDate ? new Date(filterDate) : null}
                                  dateFormat="dd.MM.yyyy"
                                  onChange={(date) => this.setState({filterDate: date})}
                                /> */}
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-12">
                    <div className="form-group">
                      <label>{this.lang("pageJump")}</label>
                      <select
                        className="form-control"
                        name="jumpPage"
                        value={jumpPage}
                        onChange={(e) => this.handleFilterChange(e)}
                      >
                        {totalPages ? (
                          Array.from(
                            { length: totalPages },
                            (_, index) => index + 1
                          ).map((ele) => {
                            return <option>{ele}</option>;
                          })
                        ) : (
                          <option disabled>Option not available</option>
                        )}
                        {/* {[1,2,3,4,5,6,7,8].map((e) => <option>{e}</option>)} */}
                      </select>
                    </div>
                  </div>
                  {/* <div className="col-lg-2 col-md-6 col-sm-12">
                            <div className="form-group">
                                <label>{this.lang("showRecord")}</label>
                                <select 
                                  className="form-control"
                                  name="authorizeFilter"
                                  value={authorizeFilter}
                                  onChange={(e) => this.handleFilterChange(e)}
                                >
                                    <option value=''>{this.lang("All")}</option>
                                    <option value={1}>{this.lang('Authorized')}</option>
                                    <option value={0}>{this.lang("de-authorized")}</option>
                                </select>
                            </div>
                        </div> */}
                  <div className="col-lg-3 col-md-6 col-sm-12">
                    <div className="form-group text-right">
                      <label
                        style={{ cursor: "pointer" }}
                        onClick={() => this.handleClearFilter()}
                      >
                        <i className="fa fa-close text-black"></i>{" "}
                        {this.lang("clearAllFilters")}
                      </label>
                      <button
                        className="btn main_search_button"
                        onClick={() =>
                          this.search(
                            this.state.jumpPage ? this.state.jumpPage : 1
                          )
                        }
                        disabled={loading}
                      >
                        <i className="fa fa-search" aria-hidden="true"></i>{" "}
                        {this.lang("Search")}
                      </button>
                    </div>
                  </div>
                </div>
                <div className="qr_listing_main">
                  <table className="table table-bordered table-responsive-md qr_list_table">
                    <thead>
                      <tr>
                        <th scope="col">{this.lang("Sr. No")}</th>
                        <th scope="col">
                          {client === "SWISS"
                            ? this.lang("VIN")
                            : this.lang("VIN")}
                        </th>
                        <th scope="col">
                          {partnerId === "HXAG-01" ||
                          partnerId === "8-200406-1" ||
                          partnerId === "1-190301-1" ||
                          partnerId === "6-200406" ||
                          partnerId === "002-sa" ||
                          partnerId === "16-220515" ||
                          partnerId === "WW-001" ||
                          partnerId === "demo-de" ||
                          partnerId === "23-230315" ||
                          partnerId === "23-230315-1"
                            ? this.lang("Schadennumber")
                            : this.lang("Estimate Id")}
                        </th>
                        <th scope="col">{this.lang("Reg Number")}</th>
                        {client === "CZ" && (
                          <th scope="col">{this.lang("registrationDate")}</th>
                        )}
                        <th scope="col">{this.lang("Make")}</th>
                        <th scope="col">{this.lang("Model")}</th>
                        <th scope="col">{this.lang("Color")}</th>
                        <th scope="col">{this.lang("Insurance Client")}</th>
                        <th scope="col">{this.lang("Date")}</th>
                        <th scope="col">{this.lang("Time")}</th>
                        <th scope="col">{this.lang("QR")}</th>
                        {/* {localStorage.getItem("client") != "SWISS" && <th scope="col">{this.lang("After Repair")}</th>} */}
                        {/* <th scope="col">{this.lang("After Repair")}</th> */}
                        <th scope="col">{this.lang("Images")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {/* loader */}
                      {loading && (
                        <tr>
                          <td colSpan={"13"}>{this.loading()}</td>
                        </tr>
                      )}
                      {/* All */}
                      {!result_status && !loading && orders.length
                        ? orders.map((order, i) => (
                            <tr key={i}>
                              <td
                                onClick={() => {
                                  // if (
                                  //   localStorage.getItem("partnerId") ===
                                  //   "002-sa"
                                  // ) {
                                    localStorage.setItem(
                                      "selectedFile",
                                      order.vin
                                    );
                                    localStorage.setItem("userSession", "");
                                    // this.props.history.push({
                                    //   pathname: "/newCreateQR",
                                    //   search: "?vin=" + order.actualVin,
                                    //   state: { detail: order, isUpdate: true },
                                    // });
                                  // }
                                }}
                                scope="row"
                                className="text-center"
                              >
                                {(current_page - 1) *
                                  (recordsPerPage
                                    ? parseInt(recordsPerPage)
                                    : 10) +
                                  i +
                                  1}
                              </td>
                              <td>
                                {client === "SWISS" ? (
                                  <span
                                    style={{
                                      textAlign: "center",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      localStorage.setItem(
                                        "selectedFile",
                                        order.vin
                                      );
                                      localStorage.setItem("userSession", "");
                                      this.props.history.push({
                                        // pathname: "/createQR",
                                        pathname: "/newCreateQR",
                                        search: "?vin=" + order.actualVin,
                                        state: {
                                          detail: order,
                                          isUpdate: true,
                                        },
                                      });
                                    }}
                                  >
                                    {order.actualVin || order.estimateId}
                                  </span>
                                ) : (
                                  <span
                                    style={{
                                      textAlign: "center",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      localStorage.setItem(
                                        "selectedFile",
                                        order.vin
                                      );
                                      localStorage.setItem("userSession", "");
                                      this.props.history.push({
                                        // pathname: "/createQR",
                                        pathname: "/newCreateQR",
                                        search: "?vin=" + order.vin,
                                        state: {
                                          detail: order,
                                          isUpdate: true,
                                        },
                                      });
                                    }}
                                  >
                                    {order.actualVin || order.estimateId || order.vin}
                                  </span>
                                )}
                              </td>
                              <td>{order.estimateId}</td>
                              <td>{order.reg}</td>
                              {client === "CZ" && (
                                <td>
                                  {order.hasOwnProperty("regDate") &&
                                    order.regDate.replaceAll("-", ".")}
                                </td>
                              )}
                              <td>{order.make}</td>
                              <td>{order.model}</td>
                              <td>{order.color}</td>
                              <td>{order.InsurenceName || order.client}</td>
                              <td>
                                {moment(
                                  order.scanDate.split(" ")[0],
                                  "YYYY-MM-DD"
                                ).format((client == "US" || client == "CANADA") ? "MM/DD/YYYY" : "DD.MM.YYYY")}
                              </td>
                              <td>{order.scanDate.split(" ")[1]}</td>
                              <td>
                                <button
                                  style={{}}
                                  className="btn btn-outline-info text-decoration-none"
                                  onClick={() => {
                                    localStorage.setItem(
                                      "selectedFile",
                                      order.vin
                                    );
                                    window.open(
                                      window.location.origin + "/ViewQR"
                                    )
                                    // this.props.history.push("ViewQR");
                                  }}
                                >
                                  {" "}
                                  <i className="fa fa-qrcode" />{" "}
                                  {this.lang("QR")}
                                  {/* <a
                                    className="text-decoration-none"
                                    // href={`https://drivenscan.app/qr/qr_b8.php?estimateID=${order.estimateId}&vin=${order.vin}_R&regno=${order.reg}&make=${order.Make}&model=${order.Model}&color=${order.Color}`}
                                    href={`https://drivenscan.app/qr/qr_b8.php?estimateID=${order.estimateId}&vin=${order.vin}&regno=${order.reg}&make=${order.make}&model=${order.model}&color=${order.color}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={() => {
                                    }}
                                  >
                                    <i className="fa fa-qrcode" /> {this.lang("QR_A")}
                                  </a> */}
                                </button>
                              </td>
                              {/* {localStorage.getItem("client") != "SWISS" && <td>
                                  <button style={{}} className="btn btn-outline-info text-decoration-none" 
                                    onClick={() => {
                                      localStorage.setItem("selectedFile", order.vin); window.open(window.location.origin+"/ViewQR") ;
                                      // this.props.history.push("ViewQR");
                                    }}
                                  > <i className="fa fa-qrcode" /> {this.lang("QR_A")}
                                  </button>
                                </td>} */}

                              <td>
                                <span>
                                  <Link
                                    className="btn btn-outline-info text-decoration-none"
                                    style={{ fontSize: 17 }}
                                    to="/ExtraImages/123"
                                    onClick={() => {
                                      localStorage.setItem(
                                        "selectedFile",
                                        order.vin
                                      );
                                    }}
                                  >
                                    <i
                                      className="fa fa-picture-o"
                                      aria-hidden="true"
                                    ></i>{" "}
                                    {this.lang("Take Pictures")}
                                  </Link>
                                </span>
                              </td>
                            </tr>
                          ))
                        : !result_status &&
                          !loading && (
                            <tr>
                              <td
                                colSpan={13}
                                className="text-center"
                                ref={(el) => {
                                  if (el) {
                                    el.style.setProperty(
                                      "text-align",
                                      "center",
                                      "important"
                                    );
                                  }
                                }}
                              >
                                {this.lang("No Data Found")}
                              </td>
                            </tr>
                          )}
                      {/* search */}
                      {result_status && !loading && result.length
                        ? result.map((order, i) => (
                            <tr key={i}>
                              <td scope="row">
                                {(searchCurrentPage - 1) *
                                  (recordsPerPage
                                    ? parseInt(recordsPerPage)
                                    : 10) +
                                  i +
                                  1}
                              </td>
                              <td>
                                {client === "SWISS" ? (
                                  <span
                                    style={{
                                      textAlign: "center",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      localStorage.setItem(
                                        "selectedFile",
                                        order.vin
                                      );
                                      localStorage.setItem("userSession", "");
                                      this.props.history.push({
                                        // pathname: "/createQR",
                                        pathname: "/newCreateQR",
                                        search: "?vin=" + order.actualVin,
                                        state: {
                                          detail: order,
                                          isUpdate: true,
                                        },
                                      });
                                    }}
                                  >
                                    {order.actualVin}
                                  </span>
                                ) : (
                                  <span
                                    style={{
                                      textAlign: "center",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      localStorage.setItem(
                                        "selectedFile",
                                        order.vin
                                      );
                                      localStorage.setItem("userSession", "");
                                      this.props.history.push({
                                        // pathname: "/createQR",
                                        pathname: "/newCreateQR",
                                        search: "?vin=" + order.vin,
                                        state: {
                                          detail: order,
                                          isUpdate: true,
                                        },
                                      });
                                    }}
                                  >
                                    {order.vin}
                                  </span>
                                )}
                              </td>
                              <td>{order.estimateId}</td>
                              <td>{order.reg}</td>
                              {client === "CZ" && (
                                <td>{order.regDate.replaceAll("-", ".")}</td>
                              )}
                              <td>{order.make}</td>
                              <td>{order.model}</td>
                              <td>{order.color}</td>
                              <td>{order.InsurenceName}</td>
                              <td>
                                {moment(
                                  order.scanDate.split(" ")[0],
                                  "YYYY-MM-DD"
                                ).format((client == "US" || client == "CANADA") ? "MM/DD/YYYY" : "DD.MM.YYYY")}
                              </td>
                              <td>{order.scanDate.split(" ")[1]}</td>
                              <td>
                                <button
                                  style={{}}
                                  className="btn btn-outline-info text-decoration-none"
                                  onClick={() => {
                                    localStorage.setItem(
                                      "selectedFile",
                                      order.vin
                                    );
                                    window.open(
                                      window.location.origin + "/ViewQR"
                                    );
                                    // this.props.history.push("ViewQR");
                                  }}
                                >
                                  {" "}
                                  <i className="fa fa-qrcode" /> QR
                                </button>
                              </td>
                              {/* {localStorage.getItem("client") != "SWISS" && <td>
                                <button style={{}} className="btn btn-outline-info text-decoration-none"
                                  onClick={() => {
                                    localStorage.setItem("selectedFile", order.vin); window.open(window.location.origin+"/ViewQR") ;
                                  }}
                                >
                                  <i className="fa fa-qrcode" /> {this.lang("QR_A")}
                                </button>
                                </td> 
                                } */}
                              <td>
                                <span>
                                  <Link
                                    className="btn btn-outline-info text-decoration-none"
                                    style={{ fontSize: 17 }}
                                    to="/ExtraImages/123"
                                    onClick={() => {
                                      localStorage.setItem(
                                        "selectedFile",
                                        order.vin
                                      );
                                    }}
                                  >
                                    <i
                                      className="fa fa-picture-o"
                                      aria-hidden="true"
                                    ></i>{" "}
                                    {this.lang("Take Pictures")}
                                  </Link>
                                </span>
                              </td>
                            </tr>
                          ))
                        : result_status &&
                          !loading && (
                            <tr className="text-center">
                              <td
                                colSpan={13}
                                className="text-center"
                                ref={(el) => {
                                  if (el) {
                                    el.style.setProperty(
                                      "text-align",
                                      "center",
                                      "important"
                                    );
                                  }
                                }}
                              >
                                {this.lang("No Data Found")}
                              </td>
                            </tr>
                          )}
                    </tbody>
                    {/* <tfoot>
                          <nav aria-label="Page navigation example">
                            <ul className="pagination justify-content-end">
                              <li className="page-item disabled">
                                <button className="btn" disabled={previous_page === null} onClick={()=>this.getQrList(previous_page)}>Previous</button>
                              </li> 

                              {previous_page && <li className="page-item"><button className="btn" onClick={()=>this.getQrList(previous_page)}>{previous_page}</button></li>}

                              <li className="page-item"><button className="btn" onClick={()=>this.getQrList(current_page)}>{current_page}</button></li>
                              {next_page && <li className="page-item" onClick={()=>this.getQrList(next_page)}><button className="btn">{next_page}</button></li>}
                              <li className="page-item">
                                <button className="btn" disabled={next_page === null} onClick={()=>this.getQrList(next_page)}>Next</button>
                              </li>
                            </ul>
                          </nav>
                        </tfoot> */}
                  </table>
                </div>
                {!result_status ? (
                  orders.length ? (
                    <div className="text-right qr_table_footer">
                      <div className="row justify-content-end">
                        <div className="col-lg-5 col-md-6 col-sm-12">
                          <nav aria-label="Page navigation example">
                            <ul className="pagination justify-content-end">
                              <li className="page-item disabled">
                                <button
                                  className="btn"
                                  disabled={previous_page === null}
                                  onClick={() => this.getQrList(previous_page)}
                                >
                                  <i
                                    className="fa fa-angle-double-left"
                                    aria-hidden="true"
                                  ></i>
                                </button>
                              </li>

                              {previous_page && (
                                <li className="page-item">
                                  <button
                                    className="btn"
                                    onClick={() =>
                                      this.getQrList(previous_page)
                                    }
                                  >
                                    {previous_page}
                                  </button>
                                </li>
                              )}

                              <li className="page-item active">
                                <button
                                  className="btn"
                                  onClick={() => this.getQrList(current_page)}
                                >
                                  {current_page === null ? 1 : current_page}
                                </button>
                              </li>
                              {next_page && (
                                <li
                                  className="page-item"
                                  onClick={() => this.getQrList(next_page)}
                                >
                                  <button className="btn">{next_page}</button>
                                </li>
                              )}
                              <li className="page-item">
                                <button
                                  className="btn"
                                  disabled={next_page === null}
                                  onClick={() => this.getQrList(next_page)}
                                >
                                  <i
                                    className="fa fa-angle-double-right"
                                    aria-hidden="true"
                                  ></i>
                                </button>
                              </li>
                            </ul>
                          </nav>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )
                ) : result.length ? (
                  <div className="text-right qr_table_footer">
                    <div className="row justify-content-end">
                      <div className="col-lg-5 col-md-6 col-sm-12">
                        <nav aria-label="Page navigation example">
                          <ul className="pagination justify-content-end">
                            <li className="page-item disabled">
                              <button
                                className="btn"
                                disabled={searchPreviousPage === null}
                                onClick={() => this.search(searchPreviousPage)}
                              >
                                <i
                                  className="fa fa-angle-double-left"
                                  aria-hidden="true"
                                ></i>
                              </button>
                            </li>

                            {searchPreviousPage && (
                              <li className="page-item">
                                <button
                                  className="btn"
                                  onClick={() =>
                                    this.search(searchPreviousPage)
                                  }
                                >
                                  {searchPreviousPage}
                                </button>
                              </li>
                            )}
                            <li className="page-item active">
                              <button
                                className="btn"
                                onClick={() => this.search(searchCurrentPage)}
                              >
                                {searchCurrentPage === null
                                  ? 1
                                  : searchCurrentPage}
                              </button>
                            </li>
                            {searchNextPage && (
                              <li
                                className="page-item"
                                onClick={() => this.search(searchNextPage)}
                              >
                                <button className="btn">
                                  {searchNextPage}
                                </button>
                              </li>
                            )}
                            <li className="page-item">
                              <button
                                className="btn"
                                disabled={searchNextPage === null}
                                onClick={() => this.search(searchNextPage)}
                              >
                                <i
                                  className="fa fa-angle-double-right"
                                  aria-hidden="true"
                                ></i>
                              </button>
                            </li>
                          </ul>
                        </nav>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default QrList;
